import { collection } from '@gogame/schemas';

import { costModelSchema } from 'scenes/Campaigns/components/CostModel/schema';

export const costModelsSchema = collection(costModelSchema).default([]);
